import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { DocumentTextIcon, ClockIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { get } from 'lodash';
import moment from 'moment';

const BcbAutoMailerGenericNotification = ({ notification }) => {
  const intl = useIntl();
  const dataString = get(notification, 'data', '{}');
  let data = {};
  
  try {
    data = JSON.parse(dataString);
  } catch (error) {
    console.warn('Failed to parse notification data:', error);
  }

  const message = get(data, 'message') || intl.formatMessage({ id: 'succession.notifications.bcb_auto_mailer.default_message' });
  const isRead = !!get(notification, 'readAt');
  const readTime = get(notification, 'readAt');

  return (
    <div className={`p-4 border-l-4 ${isRead ? 'border-succession-border bg-succession-bg-tertiary' : 'border-succession-primary bg-succession-primary-10'} hover:shadow-md transition-shadow duration-200`}>
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          {/* Icon */}
          <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${isRead ? 'bg-succession-bg-secondary' : 'bg-succession-primary'}`}>
            <DocumentTextIcon className={`w-5 h-5 ${isRead ? 'text-succession-text-muted' : 'text-white'}`} />
          </div>
          
          {/* Badge */}
          <div className={`px-3 py-1 rounded-full text-sm font-bold ${isRead ? 'bg-succession-bg-secondary text-succession-text-muted' : 'bg-succession-primary-20 text-succession-primary'}`}>
            {intl.formatMessage({ id: 'succession.notifications.bcb_auto_mailer.badge' })}
          </div>
        </div>

        {/* Unread indicator */}
        {!isRead && (
          <div className="w-3 h-3 bg-succession-primary rounded-full flex-shrink-0"></div>
        )}
      </div>

      {/* Content */}
      <div className="mb-4">
        <p className={`text-base font-medium mb-2 ${isRead ? 'text-succession-text-secondary' : 'text-succession-text-primary'}`}>
          {message}
        </p>
        
        <p className={`text-sm ${isRead ? 'text-succession-text-muted' : 'text-succession-text-secondary'}`}>
          {intl.formatMessage({ id: 'succession.notifications.bcb_auto_mailer.subtitle' })}
        </p>
      </div>

      {/* Actions */}
      <div className="flex items-center justify-between">
        <a
          href="/succession/bcp"
          className={`inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
            isRead 
              ? 'bg-succession-bg-secondary text-succession-text-secondary hover:bg-succession-hover-bg' 
              : 'bg-succession-primary text-white hover:bg-succession-primary-hover'
          }`}
        >
          <DocumentTextIcon className="w-4 h-4 mr-2" />
          {intl.formatMessage({ id: 'succession.notifications.bcb_auto_mailer.visit_builder' })}
          <ArrowRightIcon className="w-4 h-4 ml-2" />
        </a>

        {/* Timestamp */}
        <div className="flex items-center text-xs text-succession-text-muted">
          {readTime && (
            <>
              <ClockIcon className="w-3 h-3 mr-1" />
              <span>{intl.formatMessage({ id: 'succession.notifications.bcb_auto_mailer.read_at' }, { time: moment(readTime).fromNow() })}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

BcbAutoMailerGenericNotification.propTypes = {
  notification: PropTypes.shape({
    data: PropTypes.string,
    readAt: PropTypes.string,
  }).isRequired,
};

export default BcbAutoMailerGenericNotification; 